<template>
  <div class="hp-bottom-bar" v-if="isShowConsultBtn || isShowQingtingBtn">
    <div class="hp-bottom-bar-fixed">
      <!-- 倾听师 -->
      <template v-if="isShowQingtingBtn">
        <qingsuBar v-on="$listeners" :qingsuType="qingsuType" />
      </template>

      <!-- 咨询师 -->
      <template v-else-if="isShowConsultBtn">
        <div class="bar-b">
          <!-- 心乐土咨询师要显示客服按钮 -->
          <template v-if="mixinShowStudioInfo">
            <div class="bar-item" @click="_contactCustomer">
              <img
                src="~images/platform/homepage/bottom-bar-talk-icon.png"
                alt=""
              />
              <p>客服</p>
            </div>
          </template>
          <!-- 普通咨询师 -->
          <template v-else>
            <div class="bar-item" @click="sendLetter">
              <img
                src="~images/platform/homepage/bottom-bar-talk-icon.png"
                alt=""
              />
              <p>私信</p>
            </div>
          </template>

          <div class="bar-item" @click="toggleFollow">
            <template v-if="hasFollow">
              <img
                src="~images/platform/homepage/bottom-bar-agree.png"
                alt=""
              />
              <p>已关注</p>
            </template>
            <template v-else>
              <img
                src="~images/platform/homepage/bottom-bar-disagree.png"
                alt=""
              />
              <p>关注</p>
            </template>
          </div>

          <div class="btn-large-wrap">
            <template v-if="consultStatus">
              <div
                v-if="+consultStatus.service_status === 1"
                :class="['btn-large', toZxOrderBtnColor]"
                @click="toConsult"
              >
                <!-- 已登录 & 无优惠信息 -->
                <template v-if="isLogin && !minPrice">
                  <img
                    src="~images/platform/homepage/talk-icon-white.png"
                    alt=""
                  />
                  <p>立即预约</p>
                </template>
                <div v-else class="btn-large-content">
                  <p class="label">立即预约</p>
                  <p v-if="!isLogin" class="tips">
                    {{ +consultServiceInfo.price }}元/次（登录后查看可享优惠）
                  </p>
                  <template v-if="isLogin && minPrice">
                    <div class="tag">
                      单次低至 {{ +minPrice.teacher_price }}元/次
                    </div>
                  </template>
                </div>
              </div>
              <div v-else class="btn-large disabled">
                <img
                  src="~images/platform/homepage/talk-icon-white.png"
                  alt=""
                />
                <p>{{ consultStatus.status_desc }}</p>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>

    <preConsultRuleModel
      class="js-pre-consult-max-outer"
      v-model="showRuleModel"
      @toPreConsult="toPreConsult"
    />

    <customerModel
      v-model="isShowCustomerModal"
      :customerInfo="customerInfo"
    ></customerModel>
  </div>
</template>

<script>
import preConsultRuleModel from 'lib/component/vue/consult/preConsultModel.vue'
import customerModel from 'component/xlt/customerModel/index.vue'
import { EventBus } from 'component/platform/homepage/eventBus.js'
import preventScrollChain from 'utils/preventScrollChain.js'
import expertXltMixin from 'mixins/xlt/expertXltMixin.js'
import qingsuBar from 'component/platform/homepage/qingsuTeacher/qingsuBar.vue'

export default {
  mixins: [expertXltMixin],
  components: {
    customerModel,
    preConsultRuleModel,
    qingsuBar
  },
  props: {
    currentClassify: {
      type: Object,
      default: () => ({})
    },
    toZxOrderBtnColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowCustomerModal: false,
      showRuleModel: false
    }
  },
  computed: {
    customerInfo() {
      if (!this.mixinStudio) {
        return {
          wxQrcode: '',
          wxId: ''
        }
      }
      const { adviser_wx_account, adviser_wx_code } = this.mixinStudio
      return {
        wxQrcode: adviser_wx_code, // 客服微信二维码
        wxId: adviser_wx_account //客服微信号
      }
    },

    // 当前url访问的是否咨询师
    isConsultTeacher() {
      return this.$store.getters['homepage/isConsultTeacher']
    },
    // 当前url访问的是否倾听师
    isQingtingTeacher() {
      return this.$store.getters['homepage/isQingtingTeacher']
    },
    currentTab() {
      return this.$store.state.homepage.currentTab
    },
    commonRateType() {
      return this.$store.state.homepage.commonRateType
    },
    // 若该主页账号当前有倾听师身份（无咨询师身份），且倾听师身份为正常，则有【一键倾诉】按钮。
    // @郭静 如果倾听师被禁就不返回倾听师身份
    // 双重身份时，当tab是倾诉时显示
    isShowQingtingBtn() {
      return (
        (this.isQingtingTeacher && !this.isConsultTeacher) ||
        this.currentTab.name === 'qingsu' ||
        (this.currentTab.name === 'evaluate' &&
          this.commonRateType === 'qingsu')
      )
    },
    isShowConsultBtn() {
      return this.currentClassify.type === 'consult'
    },
    isShowPreConsult() {
      const { pre_consult } = this.$store.state.homepage.zxAdvancedInfo
      return pre_consult && !Array.isArray(pre_consult)
    },

    consultServiceInfo() {
      return this.$store.getters['homepage/consultServiceInfo']
    },
    userRelation() {
      return this.$store.state.homepage.userRelation
    },
    // 是否已关注
    hasFollow() {
      return this.userRelation && +this.userRelation.follow === 1
    },
    consultStatus() {
      const { consult_status } = this.$store.state.homepage.zxAdvancedInfo
      return consult_status
    },

    loginUser() {
      return this.$store.getters['loginUser']
    },
    isOwner() {
      return +this.loginUser.id === +this.$route.params.userId
    },
    isLogin() {
      return this.$store.getters.isLogin
    },
    homepage() {
      return this.$store.state.homepage
    },
    couponWillExpire() {
      const { coupon_will_expire = {} } = this.homepage.zxAdvancedInfo
      const { price = [], basic = {} } = coupon_will_expire
      let frontName = ''
      if (price.length) {
        let { price_type, cash, discount } = price[0]
        frontName =
          price_type === 'Cash'
            ? `￥${cash}优惠券`
            : price_type === 'Free'
            ? basic.max_reduce > 0
              ? `￥${basic.max_reduce}免单券`
              : ''
            : `${discount}折折扣券`
      }
      return { ...coupon_will_expire, frontName }
    },
    // 最优折扣（已登录 & 有优惠信息才会赋值）
    minPrice() {
      const { min_price } = this.$store.state.homepage.zxAdvancedInfo
      if (min_price && min_price.id) {
        return min_price
      }
      return null
    },
    qingsuType() {
      return this.$store.state.homepage.qingsuType
    }
  },
  watch: {
    showRuleModel(val) {
      this.$nextTick(() => {
        if (!!val) {
          const el = document.querySelector(
            '.js-pre-consult-max-outer .pre-consult-rule-model'
          )
          preventScrollChain(el)
        } else {
          preventScrollChain.destory()
        }
      })
    }
  },
  methods: {
    // 心乐土--联系客服
    _contactCustomer() {
      this.isShowCustomerModal = true
    },
    toPreConsult() {
      this.$trackEvent('newprofilepages_precommunicate_reserve', {})
      this._toConsult({ way: 'pre' })
    },
    toConsult() {
      this.$trackEvent('newprofilepages_reserve', {})
      this._toConsult()
    },
    sendLetter() {
      this.$emit('letter')
    },
    toggleFollow() {
      this.$emit('follow')
    },
    _toConsult({ way = '' } = {}) {
      EventBus.$emit('toZxOrder', { way })
    },
    qingting() {
      this.$trackEvent('newprofilepages_qingsu', {})
      this.routerToStaic({
        path: '/qingsu-teacher-page',
        query: {
          id: this.$route.params.userId,
          cid: this.$route.query.cid || '',
          channel_flag: 'ptgrzy_yjqs'
        }
      })
    },
    handleRuleModel() {
      this.$trackEvent('newprofilepages_precommunicate_click', {})
      this.showRuleModel = true
    },
    handleToUseCoupon() {
      const params = { coupon_id: this.couponWillExpire.basic.id }
      // 用券提醒埋点
      this.$trackEvent('newprofilepages_usecoupons_click', params)
      EventBus.$emit('toZxOrder', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.hp-bottom-bar {
  /deep/ .pre-consult-rule-model {
    max-height: calc(100vh - 6rem) !important;
  }
  width: 10rem;
  height: 200px;
  background-color: #fff;
  .hp-bottom-bar-fixed {
    width: 10rem;
    background-color: #fff;
    position: fixed;
    z-index: $hp_zIndex_bottomBar_and_header;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

  $pl: 120px;
  .bar-t {
    width: 100%;
    height: 110px;
    background-image: url('~images/platform/homepage/bottom-bar-bg-1.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-bottom: -30px;
    .bar-t-content {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: $pl;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #21252d;
      box-sizing: border-box;
      position: relative;
      .cartoon {
        width: 109px;
        height: 102px;
        object-fit: cover;
        position: absolute;
        bottom: 7px;
        left: 24px;
      }
      .new-user-select {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 128px;
        height: 32px;
        background: linear-gradient(90deg, #f14e00 0%, #feba22 100%);
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        position: absolute;
        bottom: 64px;
        left: calc(#{$pl} + 24px);
        border-radius: 100px 100px 100px 0px;
      }
      .orange {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff745b;
        margin-right: 6px;
      }
      .know-btn {
        width: 136px;
        height: 50px;
        background: linear-gradient(360deg, #fffdf5 0%, #ffffff 100%);
        border-radius: 27px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff741a;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 16px;
      }
    }
  }
  .bar-b {
    width: 100%;
    height: 148px;
    background: #ffffff;
    box-shadow: 0px -8px 20px -10px #ebefff;
    border-radius: 30px 30px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px 0 52px;
    box-sizing: border-box;
    .bar-item {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
        margin-bottom: 8px;
      }
    }
    .btn-large-wrap {
      width: 437px;
      height: 86px;
    }
    .btn-large {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-radius: 48px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      &.orange {
        background: linear-gradient(180deg, #fecec6 0%, #fc7052 100%);
      }
      &.purple {
        background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
      }
      &.disabled {
        background: rgb(204, 204, 204);
      }
      img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        margin-right: 12px;
      }
      .btn-large-content {
        text-align: center;
        .label {
          font-size: 32px;
          line-height: 36px;
        }
        .tips {
          font-size: 22px;
          font-weight: 400;
        }
      }
    }
  }
}
.tag {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  border-radius: 8px;
  top: 10px;
  right: 60px;

  height: 30px;
  background: #ffffff;
  border: 1px solid #ffa202;
  margin-bottom: 40px;
  padding: 0 7px;

  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #ffa202;
  line-height: 30px;

  &:after {
    position: absolute;
    display: inline-block;
    content: '';
    width: 14px;
    height: 4px;
    bottom: -6px;
    right: 50%;
    transform: translateY(-50%);
    background: url('~images/platform/homepage/bubble-arrow.png') 100%/100%
      no-repeat;
  }
}
.tag {
  position: absolute;
  border-radius: 8px;
  top: 10px;
  right: 60px;

  height: 30px;
  background: #ffffff;
  border: 0.0133334rem solid #ffa202;
  margin-bottom: 40px;
  padding: 0 7px;

  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #ffa202;
  line-height: 30px;

  &:after {
    position: absolute;
    display: inline-block;
    content: '';
    width: 14px;
    height: 4px;
    bottom: -0.07rem;
    right: 50%;
    transform: translateY(-50%);
    background: url('~images/platform/homepage/bubble-arrow.png') 100%/100%
      no-repeat;
  }
}
</style>
